import { useCallback, useRef } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'

export type SwUpdate = {
  waiting: boolean
  check: () => void
  activate: () => Promise<boolean>
}

export const useSwUpdate = (): SwUpdate => {
  const registration = useRef<ServiceWorkerRegistration | null>(null)
  const {
    needRefresh: [waiting],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW: (_url, found) => {
      registration.current = found ?? null
    },
  })

  const check = useCallback(() => {
    void registration.current?.update().catch(() => undefined)
  }, [])

  const activate = useCallback(async (): Promise<boolean> => {
    if (!waiting) return false
    try {
      await updateServiceWorker(true)
      return true
    } catch {
      return false
    }
  }, [updateServiceWorker, waiting])

  return { waiting, check, activate }
}
